import * as uuid from 'uuid';
import { type FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';

import ModalWindow from '@editor2/components/ModalWindow';
import { addPageToPageGroup, addPageToChapter } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import { addPageBlock } from './styles';

interface Props {
	chapterId?: string;
	pageGroupId?: string;
	index?: number;
	isShown: boolean;
	courseId: number;
	onHide: () => void;
}

const AddPageModal: FC<Props> = (props) => {
	const { chapterId, pageGroupId, index, isShown, courseId, onHide } = props;

	const dispatch = useDispatch();
	const { page_types } = useSelector((state: RootState) => state.courses[courseId].config);
	const pageTypesKeys = Object.keys(page_types);

	const [pageName, setPageName] = useState('');
	const [pageNumber, setPageNumber] = useState('');
	const [pageType, setPageType] = useState(pageTypesKeys[0]);

	const addPage = () => {
		const pageEntity = {
			family_id: uuid.v4(),
			name: pageName,
			page_number: pageNumber,
			page_type: pageType,
			type: 'NG::Traditional::Page',
			metadata: {},
			elements: []
		};

		if (pageGroupId) {
			dispatch(addPageToPageGroup({ pageGroupId, pageEntity, index, courseId }));
		} else {
			dispatch(addPageToChapter({ chapterId, pageEntity, index, courseId }));
		}
		onHide();
	};

	const title = <div>Add new page</div>;

	const footer = (
		<Button variant="success" size="sm" disabled={!pageName} onClick={addPage}>
			Add
		</Button>
	);

	return (
		<ModalWindow isShown={isShown} onHide={onHide} title={title} footer={footer}>
			<div className={addPageBlock}>
				<Form.Group>
					<Form.Label>Page type</Form.Label>
					<Form.Control as="select" onChange={(e) => setPageType(e.target.value)}>
						{pageTypesKeys.map((type) => {
							if (page_types[type].enabled) {
								return (
									<option key={type} value={type}>
										{page_types[type].human_name}
									</option>
								);
							}
						})}
					</Form.Control>
				</Form.Group>

				<Form.Group>
					<Form.Label>Number</Form.Label>
					<Form.Control
						placeholder="Enter page number"
						onChange={(e) => setPageNumber(e.target.value)}
					/>
				</Form.Group>
			</div>
			<Form.Group>
				<Form.Label>Page name</Form.Label>
				<Form.Control placeholder="Enter page name" onChange={(e) => setPageName(e.target.value)} />
			</Form.Group>
		</ModalWindow>
	);
};

export default AddPageModal;
